import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const videos = [{
  name: 'Olivia Alexandra',
  poster: 'https://cdn.magicpatterns.com/uploads/ojwtkCDBWnwFrWHcHsaFMT/Screenshot_2026-05-15_at_07.19.20.png',
  src: 'https://assets.cdn.filesafe.space/Nj4YTDNh6AbGQwNQpn2w/media/6a069e83ff331dd8790f69da.mov'
}, {
  name: 'Arturo Munoz',
  poster: 'https://cdn.magicpatterns.com/uploads/dNTVcpqkoFwcGzMJSk8HyX/Screenshot_2026-05-15_at_07.18.51.png',
  src: 'https://assets.cdn.filesafe.space/Nj4YTDNh6AbGQwNQpn2w/media/6a069e83937389dca0328f40.mov'
}];
export function TestimonialeVideos() {
  return <section className="py-20 lg:py-28 bg-white relative" data-id="element-1923">
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-1924">
        <SectionHeading eyebrow="Mărturii Video" title="Auzi-i vorbind direct" subtitle="Oameni care îți spun, cu cuvintele lor, prin ce schimbare au trecut." data-id="element-1925" />

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-1926">
          {videos.map((video, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: index % 2 * 0.1
        }} className="bg-brand-cream rounded-3xl border border-brand-gold/15 overflow-hidden shadow-sm hover:shadow-warm transition-shadow" data-id="element-1927">
              <div className="relative aspect-video bg-black" data-id="element-1928">
                <video className="w-full h-full object-cover" src={video.src} poster={video.poster} controls controlsList="nodownload nofullscreen noremoteplayback" disablePictureInPicture playsInline preload="metadata" data-id="element-1929" />
              </div>
              <div className="p-6 text-center" data-id="element-1930">
                <h4 className="font-heading font-bold text-brand-text text-xl" data-id="element-1931">
                  {video.name}
                </h4>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}